export const getRequest = async ({ url = window.appConfig.API_GATEWAY_URL, endpoint, token, signal }) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token && token !== "undefined") {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${url}/${endpoint}`, {
      method: "GET",
      headers,
      signal: signal,
    });

    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    return null;
  }
};

export const postRequest = async ({ url = window.appConfig.API_GATEWAY_URL, endpoint, data, token }) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token && token !== "undefined") {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return await fetch(`${url}/${endpoint}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  });
};

export const putRequest = async ({ url = window.appConfig.API_GATEWAY_URL, endpoint, data, token }) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token && token !== "undefined") {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return await fetch(`${url}/${endpoint}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(data),
  });
};

export const deleteRequest = async ({ url = window.appConfig.API_GATEWAY_URL, endpoint, data, token }) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token && token !== "undefined") {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return await fetch(`${url}/${endpoint}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(data),
  });
};
